import { Injectable, Type } from '@angular/core';

import { TableCell, TableCellAttribute } from 'src/app/interfaces/tables.interfaces';
import { assertNonNullish, MaybeUndefined } from 'src/app/utils';
import { CellDateComponent } from '../components/cell-date/cell-date.component';
import { CellLinkComponent } from '../components/cell-link/cell-link.component';
import { CellManageComponent } from '../components/cell-manage/cell-manage.component';
import { CellManageRelationComponent } from '../components/cell-manege-relation/cell-manage-relation.component';
import { CellRemoveComponent } from '../components/cell-remove/cell-remove.component';
import { CellTextComponent } from '../components/cell-text/cell-text.component';
import { CellUserBasicComponent } from '../components/cell-user-basic/cell-user-basic.component';
import { CellUserInfoComponent } from '../components/cell-user-info/cell-user-info.component';

@Injectable()
export class TableCellFactory {
  private readonly cellTypes: { [type: string]: Type<TableCell> } = {
    text: CellTextComponent,
    linkProfile: CellLinkComponent,
    date: CellDateComponent,
    manage: CellManageComponent,
    remove: CellRemoveComponent,
    userBasic: CellUserBasicComponent,
    userInfo: CellUserInfoComponent,
    manageRelation: CellManageRelationComponent,
  };

  public getCellType(attribute: TableCellAttribute): Type<TableCell> {
    const cellComponent: MaybeUndefined<Type<TableCell>> = this.cellTypes[attribute.value_class_front];

    assertNonNullish(cellComponent);
    return cellComponent;
  }
}
